<template>
  <div id = "page" class="container-fluid">
    <div class="row header mx-4 mt-3">
      <div class="col header-row">
        <h1>Audit Logs</h1>
      </div>

        <div class="row filter-row mb-1">
          <div class="patient-search-section mr-2">
            <b-input-group class="patient-search-border text-right">
                <b-form-input ref="searchInput"
                              placeholder="Search (Patient ID)"
                              class="patient-search"
                              v-model="searchTerm"></b-form-input>
                <b-input-group-append>
                <button class="btn btn-default patient-search-submit" type="button">
                  <font-awesome-icon icon="search"/>
                </button>
              </b-input-group-append>
            </b-input-group>
            </div>
            <div class="estimate-search-section mr-2">
            <b-input-group class="patient-search-border text-right">
              <b-form-input ref="searchInput"
                            placeholder="Search (Estimate ID)"
                            class="patient-search"
                            v-model="estimateTerm">

              </b-form-input>
              <b-input-group-append>
                <button class="btn btn-default patient-search-submit" type="button">
                  <font-awesome-icon icon="search"/>
                </button>
              </b-input-group-append>
            </b-input-group>
            </div>
            <b-form-group class="mr-2" label-class="ml-2" label="Start Date">
            <b-form-datepicker
                class="orange-border form-control datepicker"
                :hide-header="true"
                :value-as-date="true"
                :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"
                v-model="fromDate">
            </b-form-datepicker>
            </b-form-group>
            <b-form-group class="mr-2" label-class="ml-2" label="End Date">
              <b-form-datepicker
                  class="orange-border form-control datepicker"
                  :hide-header="true"
                  :value-as-date="true"
                  :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"
                  v-model="toDate">
              </b-form-datepicker>
            </b-form-group>
        </div>
    </div>
          <div class="row header">
            <div class="col ml-4">
            </div>
            <div class="row text-right mx-4 pb-2">
            <b-form-group>
              <b-dropdown variant="outline-orange" class="mr-2" menu-class="dropdown-container" :text="userSelected" v-model="userId">
              <b-dropdown-item @click.prevent="clearUser(null)">--</b-dropdown-item>
              <b-dropdown-item @click.prevent="selectUser(user)" v-for="user in users.users" :key="user.userId">{{ user.lastName + ', ' + user.firstName }}</b-dropdown-item>
            </b-dropdown>
            </b-form-group>
              </div>
        </div>

  <div class="container-fluid">
    <div class="row log-header">
      <div class="col-2">Date</div>
      <div class="col-2">Patient</div>
      <div class="col-2">User</div>
      <div class="col-2">Log</div>
      <div class="col-2">Estimate</div>
      <div class="col-2"></div>
    </div>
  <div v-for="log in auditLogs" class="row log-row" :key="log.organizationAuditLogId">
    <div class="column col-2"> {{ formatDate(log.createdAt) }}</div>
    <div class="column col-2"> {{patientDisplayName(log)}} </div>
    <div class="column col-2" v-if="log.user != null"> {{ log.user.firstName + ' ' + log.user.lastName }}</div>
    <div class="column col-2" v-else-if="log.user == null"> None </div>
    <div class="column col-2"> {{ log.action }}</div>
    <div class="column col-2" v-if="log.estimate != null"> {{ log.estimate.organizationPatientEstimateId }}</div>
    <div class="column col-2" v-else-if="log.estimate == null"> None </div>
  </div>
  </div>
    <loading-modal :visible="showingLoadingModal" :return-focus="$refs.searchInput"
                   @update:visible="visible => showingLoadingModal = visible"></loading-modal>
    <paginator :totalPages="totalPages" :currentPage="currentPage" @update:currentPage="newPage => currentPage = newPage"></paginator>
  </div>
</template>

<script>
  import api from '../services/api'
  import Paginator from '@/components/Paginator'
  import moment from 'moment'
  import _ from 'lodash'
  import store from '../services/store'
  import LoadingModal from '../components/LoadingModal'

  export default {
    name: 'AuditLogs',

    components: { Paginator, LoadingModal },

    data () {
      return {
        isLoading: false,
        errors: [],
        auditLogs: [],
        totalPages: 0,
        currentPage: 1,
        pageSize: 50,
        searchTerm: '',
        fromDate: moment().startOf('day').subtract(5, 'day').utc().toJSON(),
        toDate: moment().endOf('day').utc().toJSON(),
        day: moment().startOf('day').utc().toJSON(),
        toTime: '23:59',
        users: [],
        userId: null,
        userSelected: 'Select User',
        estimateTerm: '',
        showingLoadingModal: false,
        searchDebounceFn: null
      }
    },

    computed: {
      patient () {
        return store.patient
      },
      toDateTime () {
        if (this.toTime) {
          return moment(moment(this.toDate).format('YYYY/MM/DD') + ' ' + this.toTime, 'YYYY/MM/DD HH:mm').toDate()
        } else {
          return moment(this.toDate).toDate()
        }
      }
    },

    watch: {
      searchTerm (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      estimateTerm (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      fromDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.loadData()
        }
      },
      day (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.loadData()
        }
      },
      toDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.loadData()
        }
      },

      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadData()
          this.loadUsers()
        }
      }
    },

    methods: {
      loadData (silent = false) {

        if (!silent) {
          this.showingLoadingModal = true
        }

        if (this.isLoading) {
          return
        }
        this.errors = []
        const parameters = {
          searchTerm: this.searchTerm,
          pageSize: this.pageSize,
          page: this.currentPage,
          fromDate: this.fromDate,
          toDate: this.toDateTime,
          userId: this.userId,
          estimateTerm: this.estimateTerm
        }
        parseInt(parameters.estimateTerm)
        api.post('/Dashboard/AuditLogs', parameters).then(response => {
          this.auditLogs = response.data.auditLogs
          this.currentPage = response.data.page
          this.totalPages = Math.ceil(response.data.totalAuditLogs / this.pageSize)
          this.isLoading = false
        }).catch(error => {
          this.isLoading = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load audit logs: ' + error.message, error)
          }
        }).then(() => {
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      formatDate (date) {
        if (date) {
          return moment(date).format('MM/DD/YYYY h:mm a')
        } else {
          return ''
        }
      },

      loadUsers () {
        this.isLoading = true

        const parameters = {
          searchTerm: '',
          pageSize: 1000,
          page: 1
        }

        api.post('/Dashboard/Users/Search', parameters).then(response => {

          this.users = response.data
          this.totalPages = Math.ceil(response.data.totalUsers / this.pageSize)
          this.isLoading = false
        }).catch(error => {
          this.isLoading = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load users: ' + error.message, error)
          }
        })
      },

      selectUser (user) {
        this.userId = user.userId
        this.userSelected = user.firstName + ' ' + user.lastName
        this.loadData()
      },

      patientDisplayName (log) {
        if (log.patient != null) {
          return log.patient.firstName + ' ' + log.patient.lastName
        } else if (log.estimate != null) {
          return log.estimate.patient.firstName + ' ' + log.estimate.patient.lastName
        } else if (log.visit != null) {
          return log.visit.firstName + ' ' + log.visit.lastName
        } else {
          return 'None'
        }
      },

      clearUser () {
        this.userId = null
        this.userSelected = 'Select User'
        this.loadData()
      }
    },

    created () {
      this.searchDebounceFn = _.debounce(() => {
        if (this.searchTerm === '' || this.estimateTerm === '') {
          this.totalPages = Math.ceil(this.auditLogs.totalAuditLogs / this.pageSize)
          this.currentPage = 1
        } else {
          this.currentPage = 1
          this.totalPages = 0
        }
        this.loadData()
      }, 500)
      this.loadData()
      this.loadUsers()
    }
  }

</script>

<style scoped>
  .header div h1 {
    color: rgb(255, 70, 0);
    font-weight: lighter;
    font-size: 28px;
    margin: 0;
  }

  .header > h5 {
    margin-top: 0.5rem; /* Match bottom margin from bootstrap h5 */
  }

  .log-header div {
    padding: 0.75rem;
    vertical-align: bottom;
    border-top: 1px solid #dee2e6;
    border-bottom: 2px solid #dee2e6;
    font-weight: bold;
    border-collapse: collapse;
  }

  .log-row .column {
    padding: 0.75rem;
    vertical-align: bottom;
    border-collapse: collapse;
  }

  .log-row {
    border-bottom: 1px solid #dee2e6;
    background-color: #f9f9f9;
    /*cursor: pointer;*/
  }

  .blank-label {
    color: transparent;
  }
  .patient-search {
    min-width: 220px;
    height: 36px;
  }

  .patient-search-section {
    margin-top: 28px;
  }

  .estimate-search-section {
    margin-top: 28px;
  }

  .header-row {
    margin-top: 28px;
  }
</style>
